<template>
  <GlassPanel strong :glow="false" class="flex w-[min(92vw,420px)] flex-col gap-4 shadow-2xl motion-safe:animate-theme-suggestion" role="status" data-test="suggerimento-tema">
    <p class="flex items-center gap-2 text-xs font-semibold tracking-widest text-text-muted uppercase">
      <span class="size-1.5 rounded-full bg-accent ring-4 ring-accent/20 motion-safe:animate-theme-suggestion-dot" aria-hidden="true" />
      {{ t("layout.tema.eyebrow") }}
    </p>
    <div class="flex items-start gap-3">
      <div class="grid size-10 shrink-0 place-items-center rounded-xl border border-border bg-glass text-accent" aria-hidden="true">
        <i class="fal fa-moon-stars" />
      </div>
      <div class="min-w-0">
        <h3 class="font-display text-base leading-tight font-semibold text-text-primary">{{ t("layout.tema.titolo") }}</h3>
        <p class="mt-1.5 text-sm leading-relaxed text-text-secondary">{{ t("layout.tema.messaggio") }}</p>
      </div>
    </div>
    <div class="flex items-center justify-end gap-2">
      <UiButton variant="ghost" size="sm" :label="t('layout.tema.no_grazie')" @click="emit('rifiuta')" />
      <UiButton size="sm" icon="fal fa-moon" :label="t('layout.tema.attiva')" @click="emit('accetta')" />
    </div>
  </GlassPanel>
</template>

<script setup lang="ts">
// Proposta di passare al tema scuro quando il sistema lo usa e la scelta non è ancora stata fatta (la mostra app.vue in un Toast
// PrimeVue senza stile proprio). Emette `accetta` o `rifiuta`; chi la ospita chiude il toast.
import { useI18n } from "vue-i18n";

const emit = defineEmits<{ accetta: []; rifiuta: [] }>();
const { t } = useI18n();
</script>
